import { render, staticRenderFns } from "./SpecialRecursiveComponent.vue?vue&type=template&id=f97d7570&scoped=true&"
import script from "./SpecialRecursiveComponent.vue?vue&type=script&lang=js&"
export * from "./SpecialRecursiveComponent.vue?vue&type=script&lang=js&"
import style0 from "./SpecialRecursiveComponent.vue?vue&type=style&index=0&id=f97d7570&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97d7570",
  null
  
)

export default component.exports